import { LocalAuthority } from '@modules/local-authorities/interfaces';
import { createReducer, on } from '@ngrx/store';
import * as fromLocalAuthorities from '../actions/local-authorities.actions';

export interface LocalAuthoritiesState {
    selectedLocalAuthorities: string[];
    entities: { [_id: string]: LocalAuthority };
    loading: boolean;
    loaded: boolean;
}
export const initialState: LocalAuthoritiesState = {
    selectedLocalAuthorities: [],
    entities: {},
    loading: false,
    loaded: false
};

export const reducer = createReducer(
    initialState,
    on(fromLocalAuthorities.LoadLocalAuthorities, (state, { payload }) => ({
        ...state,
        selectedLocalAuthorities: [payload],
        loading: true
    })),
    on(fromLocalAuthorities.LoadLocalAuthoritiesSuccess, (state, { payload }) => ({
        ...state,
        entities: payload.reduce((result: { [_id: string]: LocalAuthority }, filter: LocalAuthority) => {
            result[filter._id] = filter;
            return result;
        }, {}),

        loading: false,
        loaded: true
    })),
    on(fromLocalAuthorities.LoadLocalAuthoritiesFail, (state) => ({
        ...state,
        loading: false,
        loaded: false
    }))
);

export const getSelectedLocalAuthorities = (state: LocalAuthoritiesState) => state.selectedLocalAuthorities;
export const getLocalAuthoritiesEntities = (state: LocalAuthoritiesState) => state.entities;
export const getLocalAuthoritiesLoading = (state: LocalAuthoritiesState) => state.loading;
export const getLocalAuthoritiesLoaded = (state: LocalAuthoritiesState) => state.loaded;
